module.exports = __webpack_public_path__ + "img/user_default_invite.a5206cac.png";